<div class="preview-table">
  <table>
    <thead>
      <tr class="border-bottom">
        <th class="header-text row-number-header" i18n>Row</th>
        <th *ngFor="let column of columns" class="header-text">
          {{ column !== 'SIN' ? (column | humanReadable) : column }}
        </th>
      </tr>
    </thead>
    <tbody *ngIf="!isLoading; else loading">
      <tr *ngFor="let rec of recordsToDisplay$ | async">
        <td class="row-column">
          {{ rec['ROW_NUMBER'] }}
        </td>
        <td [class.error]="!rec['LAST NAME']">
          {{ rec['LAST NAME'] }}
        </td>
        <td [class.error]="!rec['FIRST NAME']">
          {{ rec['FIRST NAME'] }}
        </td>
        <td [class.error]="!rec['DATE_OF_BIRTH']">
          {{ rec['DATE_OF_BIRTH'] ? (rec['DATE_OF_BIRTH'] | date : 'MMM dd, yyyy') : null }}
        </td>
        <td [class.error]="!rec?.SIN">
          <app-sin-display-field [sin]="rec?.SIN?.toString(10) ?? null" />
        </td>
        <td [class.error]="!rec['EMAIL']">
          {{ rec['EMAIL'] }}
        </td>
        <td [class.error]="!rec['EMPLOYMENT_START']">
          {{ rec['EMPLOYMENT_START'] ? (rec['EMPLOYMENT_START'] | date : 'MMM dd, yyyy') : null }}
        </td>
        <td [class.error]="!rec['EMPLOYMENT_TYPE']">
          {{ rec['EMPLOYMENT_TYPE'] }}
        </td>
        <td [class.error]="!rec['PROVINCE_OF_EMPLOYMENT']">
          {{ rec['PROVINCE_OF_EMPLOYMENT'] }}
        </td>
        <td [class.error]="!rec['WORK_FROM_HOME']">
          {{ rec['WORK_FROM_HOME'] }}
        </td>
        <td [class.error]="!rec['CONTRIBUTION_START']">
          {{ rec['CONTRIBUTION_START'] ? (rec['CONTRIBUTION_START'] | date : 'MMM dd, yyyy') : null }}
        </td>
      </tr>
    </tbody>
  </table>
</div>

<ng-template #loading>
  <tbody>
    <tr *ngFor="let number of [1, 2, 3, 4, 5]">
      <td class="row-column">
        {{ number }}
      </td>
      <td>
        <lib-loading-shimmer [borderRadius]="'1.5rem'" [height]="'1rem'" [width]="'2.5rem'" />
      </td>
      <td>
        <lib-loading-shimmer [borderRadius]="'1.5rem'" [height]="'1rem'" [width]="'2.5rem'" />
      </td>
      <td>
        <lib-loading-shimmer [borderRadius]="'1.5rem'" [height]="'1rem'" [width]="'5rem'" />
      </td>
      <td>
        <lib-loading-shimmer [borderRadius]="'1.5rem'" [height]="'1rem'" [width]="'5rem'" />
      </td>
      <td>
        <lib-loading-shimmer [borderRadius]="'1.5rem'" [height]="'1rem'" [width]="'10rem'" />
      </td>
      <td>
        <lib-loading-shimmer [borderRadius]="'1.5rem'" [height]="'1rem'" [width]="'5rem'" />
      </td>
      <td>
        <lib-loading-shimmer [borderRadius]="'1.5rem'" [height]="'1rem'" [width]="'2.5rem'" />
      </td>
      <td>
        <lib-loading-shimmer [borderRadius]="'1.5rem'" [height]="'1rem'" [width]="'5rem'" />
      </td>
      <td>
        <lib-loading-shimmer [borderRadius]="'1.5rem'" [height]="'1rem'" [width]="'2.5rem'" />
      </td>
      <td>
        <lib-loading-shimmer [borderRadius]="'1.5rem'" [height]="'1rem'" [width]="'5rem'" />
      </td>
    </tr>
  </tbody>
</ng-template>
